import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const root = css`
  padding: ${size[48]} ${size[16]};
`
